





















import {
  Vue,
  Component,
  Prop,
  Emit,
  Provide,
} from "@/shared/vuepack";
import type { TabComponent } from "@/employer/types";

@Component
export default class CommonTabs extends Vue {
  @Prop({ default: false }) forceWordSpacing!: boolean;
  @Prop({ default: "16px" }) tabFontSize!: string;
  @Prop({ default: "182px" }) tabWidth!: string;

  tabs: TabComponent[] = [];

  @Provide("registerTab")
  get registerTab () {
    return this.addTab;
  }

  @Emit("tabEvent")
  selectTab (selectedTab: TabComponent): string {
    this.tabs.forEach(tab => {
      tab.active = false;
    });
    selectedTab.active = true;
    return selectedTab.tabTitle;
  }

  addTab (tab: TabComponent): void {
    if (this.tabs.length === 0) {
      tab.active = true;
    }
    this.tabs.push(tab);
  }
}
